// extracted by mini-css-extract-plugin
export var active = "_g7-2";
export var recordingDot = "_g7-1";
export var recordingIndicator = "_g7-0";